import { Vue, Component, Prop, Watch, Setup } from "@wagich/vue-facing-decorator-metadata";
import { enforce, test } from "vest";
import { CustomFormField } from "../custom-form-field";

import { render } from "./radio-group-field.html";

@Component({
	render
})
export class RadioGroupField extends CustomFormField {
	createValidator(data: any) {
		if (this.field.required) {
			test(this.field.name, "Bitte wählen Sie eine Option aus.", () => {
				enforce(data[this.field.name]).condition(value => this.field.values?.includes(value)).isNotEmpty();
			});
		}
	}
}
